export default function selectValue (opts, val, allowNull) {
	// Allow null to programatically wipe out optsion + selection...used in realtor brokerage typeahead system.
	if(val == null && !allowNull) { return }
	if(typeof val == 'object' && !allowNull) {
		return opts.filter(r => val.includes(r.value))
	}
	else {
		return opts.filter(r => val === r.value)
	}
}